import {
  Sidebar,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarScrollWrapper,
  SidebarSpace,
} from '@backstage/core-components'
import { NavContentBlueprint, NavContentComponentProps } from '@backstage/plugin-app-react'
import { SidebarSearchModal } from '@backstage/plugin-search'
import { Settings as SidebarSettings, UserSettingsSignInAvatar } from '@backstage/plugin-user-settings'
import SearchIcon from '@material-ui/icons/Search'

import { SidebarLogo } from '../components'

/**
 * Custom nav bar content for the New Frontend System. Registered via
 * {@link NavContentBlueprint} in `appModule`. The surrounding `SidebarPage` and
 * the page content come from the `app/layout` extension, so this component only
 * renders the `Sidebar`.
 *
 * The menu items are not hardcoded — they are discovered from the page
 * extensions installed in the app (each contributes a `NavItem` extension) and
 * rendered here via `navItems`.
 */
const navSidebar = ({ navItems }: NavContentComponentProps) => {
  // Rendered by a different section
  navItems.take('page:search')
  navItems.take('page:user-settings')

  const discovered = navItems.withComponent(item => (
    <SidebarItem icon={() => item.icon} to={item.href} text={item.title} />
  ))
  const mainMenuItems = ['page:catalog', 'page:catalog-graph', 'page:api-docs', 'page:techdocs'].map(id =>
    discovered.take(id)
  )

  return (
    <Sidebar>
      <SidebarLogo />
      <SidebarGroup label="Search" icon={<SearchIcon />} to="/search">
        <SidebarSearchModal />
      </SidebarGroup>
      <SidebarDivider />
      <SidebarGroup label="Catalog">
        <SidebarScrollWrapper>{mainMenuItems}</SidebarScrollWrapper>
      </SidebarGroup>
      <SidebarSpace />
      <SidebarGroup label="Menu">
        <SidebarScrollWrapper>{discovered.rest({ sortBy: 'title' })}</SidebarScrollWrapper>
      </SidebarGroup>
      <SidebarDivider />
      <SidebarGroup label="Settings" icon={<UserSettingsSignInAvatar />} to="/settings">
        <SidebarSettings />
      </SidebarGroup>
    </Sidebar>
  )
}

export const navContent = NavContentBlueprint.make({
  params: {
    component: navSidebar,
  },
})
